import { makeImageUrls, ImageProps } from "@ezbuy/smartimagesrc";

const defaultImage = "https://t.rightinthebox.com/tights/litb/y67ncix2b4w0_ador_banner_456.png";

export function* imageSourceGenerator(
	originSrc: string,
	params: ImageProps,
	fallbackSrc: string | false = defaultImage,
) {
	const urls = makeImageUrls(originSrc, params);

	if (fallbackSrc) {
		urls.push(fallbackSrc);
	}
	for (let i = 0, l = urls.length; i < l; i++) {
		yield urls[i];
	}
	return originSrc;
}
